import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Location({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22.6667L12.4846 23.1245L12 23.6374L11.5154 23.1245L12 22.6667ZM11.3671 20.9276C11.6113 21.2217 11.8259 21.4716 12 21.6704C12.1741 21.4716 12.3887 21.2217 12.6329 20.9276C13.3098 20.1122 14.2117 18.9599 15.1123 17.6118C16.9354 14.8831 18.6667 11.4786 18.6667 8.47618C18.6667 4.91591 15.6985 1.99999 12 1.99999C8.30145 1.99999 5.33333 4.91591 5.33333 8.47618C5.33333 11.4786 7.06463 14.8831 8.88766 17.6118C9.78833 18.9599 10.6902 20.1122 11.3671 20.9276ZM20 8.47618C20 11.9024 18.0646 15.593 16.221 18.3525C15.2883 19.7485 14.3569 20.9384 13.6588 21.7792C13.3094 22.2 13.0178 22.5344 12.8126 22.7644C12.71 22.8794 12.629 22.9684 12.5731 23.0291C12.5452 23.0595 12.5236 23.0828 12.5087 23.0988L12.4914 23.1173L12.4867 23.1223L12.4853 23.1237L12.4849 23.1242C12.4847 23.1244 12.4846 23.1245 12 22.6667C11.5154 23.1245 11.5153 23.1244 11.5151 23.1242L11.5147 23.1237L11.5133 23.1223L11.5086 23.1173L11.4913 23.0988C11.4764 23.0828 11.4548 23.0595 11.4269 23.0291C11.371 22.9684 11.29 22.8794 11.1874 22.7644C10.9822 22.5344 10.6906 22.2 10.3412 21.7792C9.64314 20.9384 8.71167 19.7485 7.779 18.3525C5.93537 15.593 4 11.9024 4 8.47618C4 4.14667 7.59837 0.666656 12 0.666656C16.4016 0.666656 20 4.14667 20 8.47618ZM10 8.6667C10 9.77127 10.8954 10.6667 12 10.6667C13.1046 10.6667 14 9.77127 14 8.6667C14 7.56213 13.1046 6.6667 12 6.6667C10.8954 6.6667 10 7.56213 10 8.6667ZM12 12C10.1591 12 8.66667 10.5076 8.66667 8.6667C8.66667 6.82575 10.1591 5.33336 12 5.33336C13.841 5.33336 15.3333 6.82575 15.3333 8.6667C15.3333 10.5076 13.841 12 12 12Z"
        fill={iconColor}
      />
    </Svg>
  );
}
